/*
 * Footer menüsündeki bağlantının sitede gerçekten çizilip çizilmeyeceği.
 *
 * `/settings` yanıtı `/sayfa/<adres>` bağlantılarını yayındaki footer
 * sayfalarına göre süzer (backend services/footer_pages.py →
 * `prune_menu_groups`): sayfası olmayan ya da pasif olan bağlantı sitede
 * **sessizce** düşer, bağlantısı kalmayan grup da tümüyle kaybolur. Panel bunu
 * söylemiyordu ve şikâyet "footer'ı panelde düzenledik, siteye gelmiyor" diye
 * geldi (Betrun, 02.10.2026: 17 varsayılan sayfanın yalnızca ikisi yayındaydı).
 *
 * Kalıp backend'deki `PAGE_URL_RE` ile **aynı** kalmalıdır; ayrışırsa panel
 * sitede görünen bir bağlantıyı gizli, gizleneni görünür sayardı.
 */

const PAGE_URL_RE = /^\/sayfa\/([^/?#]+)\/?(?:[?#].*)?$/;

export const footerPageSlug = (url) => {
  const match = PAGE_URL_RE.exec(String(url || '').trim());
  return match ? match[1] : null;
};

/**
 * Bağlantı sitede çizilmeyecekse sebebi: `missing` (o adreste sayfa yok) ya
 * da `inactive` (sayfa pasif). Footer sayfası olmayan bağlantı (dış adres,
 * `/promosyonlar`) ve sayfa listesi okunamadığında `null` döner — liste
 * bilinmeden uyarı basmak her bağlantıyı yanlışlıkla gizli gösterirdi.
 */
export const hiddenLinkReason = (url, pages) => {
  if (!Array.isArray(pages)) return null;
  const slug = footerPageSlug(url);
  if (!slug) return null;
  const page = pages.find((item) => String(item?.slug || '').trim() === slug);
  if (!page) return 'missing';
  return page.is_active ? null : 'inactive';
};

export const HIDDEN_LINK_TEXT = {
  missing: 'Bu adreste footer sayfası yok — bağlantı sitede gösterilmez.',
  inactive: 'Sayfa pasif — bağlantı sitede gösterilmez.',
};

/** Menülerde sitede gösterilmeyecek bağlantı sayısı. */
export const countHiddenLinks = (groups, pages) => (groups || []).reduce(
  (total, group) => total + (group?.links || [])
    .filter((link) => hiddenLinkReason(link?.url, pages)).length,
  0,
);
